export default __webpack_public_path__ + "static/2434-4bd3f5660abd4a6155627d781e5977a5.gif";